import { capitalize } from 'lodash'

import i18n from 'modules/core/lib/i18n'

export const formatValue = (value: string | boolean | number | undefined) => {
  if (typeof value === 'boolean') {
    return value ? capitalize(i18n.t('common.yes')) : capitalize(i18n.t('common.no'))
  }

  return value
}
